import { EXO_SKELETON_EVENT_NAMES } from './consts';
import { notInExoSkeletonError } from './internal';
import { createPostMessageEventHandler, isInExoSkeleton, sendRuntimeDataEvent } from './runtime';
export const NAVIGATION_HOST_MESSAGE_EVENT_NAME = EXO_SKELETON_EVENT_NAMES.NAVIGATION_HOST_MESSAGE_EVENT_NAME;
function isNavigationDataEvent(data) {
  return (data === null || data === void 0 ? void 0 : data.type) === NAVIGATION_HOST_MESSAGE_EVENT_NAME;
}

/**
 * Used to create a host for the ExoSkeleton navigation.
 */
export function createNavigationListener(_ref) {
  let {
    onNavigate
  } = _ref;
  if (!isInExoSkeleton()) {
    throw notInExoSkeletonError({
      source: 'createNavigationListener'
    });
  }
  return createPostMessageEventHandler(function (_ref2) {
    let {
      data
    } = _ref2;
    if (isNavigationDataEvent(data)) {
      onNavigate(data);
    }
  });
}
export function navigate(to) {
  if (!isInExoSkeleton()) {
    throw notInExoSkeletonError({
      source: 'navigate'
    });
  }
  return sendRuntimeDataEvent(NAVIGATION_HOST_MESSAGE_EVENT_NAME, {
    to
  });
}
//# sourceMappingURL=navigation.js.map